<!-- Pagination -->
<div
  class="view-scene-pagination"
  *ngIf="(chapterCount$ | async) > 1 && isEnabled(viewLayout.Pagination)">
  <button
    app-scene-button
    [matTooltip]="previousChapterLabel"
    (click)="handlePreviousChapter()"
    [disabled]="(chapterIndex$ | async) === 0"
    matTooltipPosition="right">

    <app-icon icon="arrow-left"></app-icon>
  </button>

  <button
    app-scene-button
    [matTooltip]="nextChapterLabel"
    (click)="handleNextChapter()"
    [disabled]="(chapterIndex$ | async) === ((chapterCount$ | async) - 1)"
    matTooltipPosition="left">

    <app-icon icon="arrow-right"></app-icon>
  </button>
</div>